import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';

import App from './lib/App/App.svelte';
import config from './config' ;

const app = new App({
    target: document.getElementById('enrollment-external-list-enrolment-courses'),
    props: config
});

export default app;
